//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
let d=[[[0,"CreateDraftingComponent",1,0],[0,"GridSettings",1,0],[0,"ModelBasedAlwaysStart",1,0],[0,"ModelBasedInsertSheet",1,0],[0,"ModelBasedProjectedView",1,0],[0,"SettingsOrigination",1,0],[0,"StandAloneInsertSheet",1,0],[0,"StandAloneProjectToView",1,0],[0,"StandAloneProjectedView",1,0],[0,"StandAloneViewCreation",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.GeneralWorkFlowBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.GeneralWorkFlowBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.GeneralWorkFlowBuilder.ModelBasedAlwaysStartType = Object.freeze({
    "ViewCreationWizard" : "ViewCreationWizard", "BaseViewCommand" : "BaseViewCommand", "NoViewCommands" : "NoViewCommands"});

SPLM.Drawings.GeneralWorkFlowBuilder.SettingsOrientationType = Object.freeze({
    "DrawingTemplate" : "DrawingTemplate", "DrawingStandard" : "DrawingStandard"});

SPLM.Drawings.GeneralWorkFlowBuilder.GridSettingsType = Object.freeze({
    "Drafting" : "Drafting", "Sketch" : "Sketch", "SheetZone" : "SheetZone"});

export default SPLM;